@if (emailSent()) {
  <!-- ── Écran post-inscription : vérifier la boîte mail ── -->
  <div class="email-sent">
    <div class="email-sent__icon">
      <ng-icon name="iconoirCheckCircle" size="28"></ng-icon>
    </div>
    <h3 class="email-sent__title">Vérifiez votre boîte mail</h3>
    <p class="email-sent__body">
      Un email de confirmation a été envoyé à<br>
      <strong>{{ form.getRawValue().email }}</strong>
    </p>
    <p class="email-sent__hint" id="su-otp-hint">
      Cliquez sur le lien dans l'email, ou saisissez le code à 6 chiffres reçu :
    </p>
    <div class="email-sent__otp" role="group" aria-labelledby="su-otp-hint" [attr.aria-describedby]="otpError() ? 'su-otp-error' : null">
      <ngx-otp-input
        [options]="otpOptions"
        [status]="otpStatus"
        (otpChange)="verifySignupCode($event)"></ngx-otp-input>
      @if (otpPending()) {
        <p class="email-sent__otp-pending">Vérification…</p>
      }
      @if (otpError()) {
        <p class="email-sent__otp-error" id="su-otp-error" role="alert">{{ otpError() }}</p>
      }
    </div>
    <div class="email-sent__actions">
      <button
        type="button"
        class="resend-btn"
        (click)="resendEmail()"
        [disabled]="resendPending() || resendCountdown() > 0"
      >
        @if (resendPending()) {
          <ng-icon name="iconoirRefreshDouble" size="14" class="spin"></ng-icon>
          Envoi en cours…
        } @else {
          Renvoyer l'email
          @if (resendCountdown() > 0) {
            <span class="resend-btn__counter">({{ resendCountdown() }} s)</span>
          }
        }
      </button>
      <button type="button" class="resend-btn resend-btn--secondary" (click)="editEmail()">
        Modifier l'adresse
      </button>
    </div>
    <p class="email-sent__spam">Pensez à vérifier vos spams si vous ne le trouvez pas.</p>
  </div>
} @else {
  <!-- ── Formulaire d'inscription ── -->
  <form [formGroup]="form" class="signup-form" (ngSubmit)="signUp()">

    <div class="form-group">
      <label for="su-email" class="form-label">Adresse email <span class="required">*</span></label>
      <div class="input-wrapper">
        <ng-icon name="iconoirMail" class="input-icon" size="18"></ng-icon>
        <input
          autocomplete="email"
          name="email"
          id="su-email"
          type="email"
          formControlName="email"
          class="form-input"
          placeholder="vous@entreprise.com"
        >
      </div>
      @if (form.controls.email.touched) {
        @if (form.controls.email.hasError('required')) {
          <span class="error-message">Saisissez votre adresse email professionnelle.</span>
        } @else if (form.controls.email.hasError('email')) {
          <span class="error-message">Cette adresse email n'est pas valide. Exemple : vous&#64;entreprise.com</span>
        }
      }
    </div>

    <div class="form-row">
      <div class="form-group">
        <label for="su-lastName" class="form-label">Nom <span class="required">*</span></label>
        <input
          autocomplete="family-name"
          name="lastName"
          id="su-lastName"
          type="text"
          formControlName="lastName"
          class="form-input"
          placeholder="Dupont"
        >
        @if (form.controls.lastName.touched && form.controls.lastName.hasError('required')) {
          <span class="error-message">Indiquez votre nom.</span>
        }
      </div>

      <div class="form-group">
        <label for="su-firstName" class="form-label">Prénom <span class="required">*</span></label>
        <input
          autocomplete="given-name"
          name="firstName"
          id="su-firstName"
          type="text"
          formControlName="firstName"
          class="form-input"
          placeholder="Jean"
        >
        @if (form.controls.firstName.touched && form.controls.firstName.hasError('required')) {
          <span class="error-message">Indiquez votre prénom.</span>
        }
      </div>
    </div>

    <div class="form-group">
      <label for="su-password" class="form-label">Mot de passe <span class="required">*</span></label>
      <div class="input-wrapper">
        <ng-icon name="iconoirLock" class="input-icon" size="18"></ng-icon>
        <input
          autocomplete="new-password"
          name="password"
          id="su-password"
          type="password"
          formControlName="password"
          class="form-input"
          placeholder="Minimum 8 caractères"
          aria-describedby="su-password-rules"
          (focus)="showPasswordRules.set(true)"
          (blur)="showPasswordRules.set(false)"
        >
      </div>
      @if (showPasswordRules() || (form.controls.password.touched && form.controls.password.invalid)) {
        <ul class="password-rules" id="su-password-rules" aria-live="polite">
          <li [class.ok]="passwordRule('length')">8 caractères minimum</li>
          <li [class.ok]="passwordRule('upper')">Une majuscule</li>
          <li [class.ok]="passwordRule('lower')">Une minuscule</li>
          <li [class.ok]="passwordRule('digit')">Un chiffre</li>
          <li [class.ok]="passwordRule('special')">Un caractère spécial (- _ . ! @ # …)</li>
        </ul>
        @if (form.controls.password.touched && form.controls.password.hasError('required')) {
          <span class="error-message">Choisissez un mot de passe.</span>
        } @else if (form.controls.password.touched && form.controls.password.invalid) {
          <span class="error-message">Il manque encore les éléments non cochés ci-dessus.</span>
        }
      }
    </div>

    <div class="form-group checkbox-group">
      <label class="checkbox-label">
        <input
          type="checkbox"
          formControlName="conditions"
          class="checkbox-input"
        >
        <!-- Conditions gérées en interne : page /terms du site, plus de service tiers -->
        <span class="checkbox-text">
          J'accepte les <a routerLink="/documents/terms" target="_blank" class="link">conditions d'utilisation</a>
        </span>
      </label>
      @if (form.controls.conditions.touched && form.controls.conditions.hasError('required')) {
        <span class="error-message">Acceptez les conditions d'utilisation pour créer votre espace.</span>
      }
    </div>

    <div class="form-group checkbox-group">
      <label class="checkbox-label">
        <input
          type="checkbox"
          formControlName="optinMarketing"
          class="checkbox-input"
        >
        <span class="checkbox-text">
          Je souhaite recevoir les actualités et offres Mokah+ par email
        </span>
      </label>
    </div>

    @if (errorMessage()) {
      <p class="form-error-banner" role="alert">
        <ng-icon name="iconoirWarningCircle" size="18"></ng-icon>
        <span>{{ errorMessage() }}</span>
      </p>
    }

    <div class="submit-actions">
      <app-btn
        [config]="{
          type: 'filled',
          color: 'coffee',
          icon: 'iconoirArrowRight',
          disabled: pending()
        }"
        (click)="signUp()"
      >
        @if (pending()) {
          Création du compte…
        } @else {
          Démarrer l'essai gratuit de 14 jours
        }
      </app-btn>
    </div>

    <!-- Argument d'entrée : assumé visuellement plutôt qu'en note de bas de page -->
    <p class="no-card">
      <ng-icon name="iconoirCreditCardSlash" size="16" class="no-card__icon"></ng-icon>
      <span><strong>14 jours d'essai gratuit</strong> — sans carte bancaire requise, sans engagement.</span>
    </p>
  </form>
}
